import { render, staticRenderFns } from "./TokenExInput.vue?vue&type=template&id=5a86504e"
import script from "./TokenExInput.ts?vue&type=script&lang=ts&external"
export * from "./TokenExInput.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports